import styled from 'styled-components'
import { Link } from 'react-router-dom'

const AntLinkStyled = styled(Link)``

export default AntLinkStyled
